import React from 'react';
import DateField from 'Components/ComponentLibrary/Components/Uncategorized/DateField';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import PropTypes from 'prop-types';
import { monthYear } from 'Consts/DateFormats';
import { FDStack } from '@facet-wealth/design';
import { useYearPicker } from 'Components/ComponentLibrary/Molecules/dateOrYearPicker/useYearPicker';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('DateOrYearPickerWhatIf', ((theme) => ({
  root: {
    // The old whatif-style inputs have this CSS, so we need to add it here so that this input fits in with the rest of them
    marginBottom: theme.spacing(1),
  },
})));

export default function DateOrYearPickerWhatIf({
  value, onChange, label, disabled, startDateField, yearLabel, helperText, title, isAge, test,
}) {
  const classes = useStyles();
  const yearPicker = useYearPicker({
    startDateField,
    yearLabel,
    isAge,
    dateLabel: label,
    dateValue: value,
    dateOnChange: onChange,
  });
  return (
    <div className={classes.root}>
      <FDStack spacing={1} direction="row">
        <DateField
          label={label}
          title={title}
          value={value}
          onChange={onChange}
          openTo={'year'}
          views={['year', 'month']}
          format={monthYear}
          disabled={disabled}
          placeholder={monthYear}
          helperText={helperText}
          test={test}
        />
        {
        yearPicker ? (
          <TextField
            type={'number'}
            disabled={disabled}
            title={yearPicker.label}
            test={isAge ? test.replace('date', 'age').replace('Date', 'Age') : undefined}
            {...yearPicker}
          />
        ) : null
      }
      </FDStack>
    </div>
  );
}

DateOrYearPickerWhatIf.defaultProps = {
  value: undefined,
  label: undefined,
  disabled: false,
  isAge: false,
  yearLabel: undefined,
  helperText: undefined,
  title: undefined,
};

DateOrYearPickerWhatIf.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  startDateField: PropTypes.string.isRequired,
  isAge: PropTypes.bool,
  yearLabel: PropTypes.string,
  helperText: PropTypes.string,
  title: PropTypes.string,
};
